import React from 'react';
import OfferingsContent from '../function-components/OfferingsContent';

function Offerings() {
  return (
    <>
    <OfferingsContent />
    </>
  )
}

export default Offerings